<template>
  <div class="feePropertyList">
    <el-card>
      <div class="feeMsg">
        <el-form
          :model="diaFree"
          :rules="rules"
          ref="diaFree"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-row>
            <el-col :span="5">
              <el-tag size="medium" effect="dark" style="font-size: 15px; width:150px; text-align:center;">缴费信息</el-tag>
            </el-col>
            <el-col :span="19" align="right" >
              <el-button style="line-height: 3px;" type="primary" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
           </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row style="margin-left:5%">
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_feeId')" prop="feeId">{{diaFree.feeId}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_feeFlagName')">{{diaFree.feeFlagName}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_feeTypeCdName')">{{diaFree.feeTypeCdName}}</el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-left:5%">
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_payerObjName')">{{diaFree.roomDescribe}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_feeName')">{{diaFree.feeName}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_stateNames')">{{diaFree.stateName}}</el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-left:5%">
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_buildTime')">{{diaFree.startTime| timeYMD}}</el-form-item>
            </el-col>
            <el-col :span="8">
              
               <el-form-item :label="$t('lang.lab_startTime')" v-if="getEndTime(diaFree) == '―'">{{getEndTime(diaFree)}}</el-form-item>
               <el-form-item :label="$t('lang.lab_startTime')" v-else>{{getEndTime(diaFree)|timeYMD}}</el-form-item>
               <!-- <el-form-item :label="$t('lang.lab_startTime')" >
                 <template slot-scope="scope">
                   <div v-if="scope.row.state == '2009001'">{{getEndTime(diaFree)}}</div>
                   <div v-else>{{getEndTime(diaFree)| time}}</div>
                  </template>
                 </el-form-item> -->
             
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_finishTime')" v-if="getDeadlineTime(diaFree) == '―'">{{getDeadlineTime(diaFree)}}</el-form-item>
              <el-form-item :label="$t('lang.lab_finishTime')" v-else>{{getDeadlineTime(diaFree)|timeYMD}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('lang.lab_stateNames')"
                v-if="diaFree.amount != '-1.00'"
              >{{diaFree.amount}}</el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-left:5%">
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_buildArea')">{{diaFree.builtUpArea}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_squarePrice')">{{diaFree.squarePrice}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('lang.lab_additionalAmount')">{{diaFree.additionalAmount}}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card style="min-height:65%;margin-top:10px;" class="feehistoryCard">
      <el-row>
        <el-col>
          <el-tag size="medium" effect="dark" style="font-size: 15px;width:150px; text-align:center;">缴费历史</el-tag>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div class="filters feePro">
        <el-form :inline="true">
          <!-- 选择日期 -->
          <el-form-item :label="$t('lang.lab_AdverBeginDate')">
            <el-date-picker
              class="select"
              v-model="diaFreeProperty.startTime"
              type="date"
              value-format="timestamp"
              :placeholder="$t('lang.lab_AdverSelectBeginDate')"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_AdverEndDate')">
            <el-date-picker
              class="select"
              v-model="diaFreeProperty.endTime"
              type="date"
              value-format="timestamp"
              :placeholder="$t('lang.lab_AdverSelsetEndDate')"
            ></el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="feeDetailHistory()">{{$t('lang.btn_search')}}</el-button>
          </el-form>
          <el-table
            :data="diaHistory"
            class="diaFreeTable"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            :cell-style="{padding: '15px 0 !important'}"
            :expand-row-keys="expands"
            @expand-change="rowClick"
            :row-key="getRowKeys"
          >
            <!-- checkbox -->
            <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
            <!-- 序号 -->
            <el-table-column
              type="index"
              :index="indexMethod"
              align="center"
              :label="$t('lang.lab_index')"
              width="100px"
            ></el-table-column>
            <!-- 展开区域-->
            <el-table-column width="30" type="expand">
              <template slot-scope="scope">
                <el-table label-position="left" inline class="demo-table-expand" :data="scope.row.ruleItemData" max-height="300">
                  <el-table-column label="收费项目" prop="feeName"></el-table-column>
                  <el-table-column label="应收金额" prop="receiveAmount"></el-table-column>
                  <el-table-column label="收款金额" prop="thisAmount"></el-table-column>
                  <el-table-column label="折扣金额" prop="discountDetail"></el-table-column>
                  <el-table-column label="费用期间" prop="period">
                    <template slot-scope="scope">
                      <span v-if="scope.row.feeFlag == '1003006'">
                        {{scope.row.period}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="计费开始时间" prop="beginDate">
                    <template slot-scope="scope">
                      <span v-if="scope.row.feeFlag == '1003006'">
                        {{scope.row.beginDate|timeYMD}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="计费结束时间" prop="minEndDate">
                    <template slot-scope="scope">
                      <span v-if="scope.row.feeFlag == '1003006'">
                        {{scope.row.minEndDate|timeYMD}}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="收款人" prop="creatorName"></el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <!-- 缴费ID -->
            <el-table-column width="210px" prop="detailId" :label="$t('lang.lab_detailId')"></el-table-column>
            <!-- 周期 -->
            <!-- <el-table-column :label="$t('lang.lab_cycles')">
               <template slot-scope="scope">
                  {{scope.row.cycles}}月
               </template>
            </el-table-column> -->
            <!-- 应收金额 -->
            <el-table-column :label="$t('lang.lab_amountOwed')">
              <template slot-scope="scope">
                {{scope.row.receivableAmount}}元
              </template>
            </el-table-column>
            <!-- 实收金额 -->
            <el-table-column :label="$t('lang.lab_receivedAmountH')">
               <template slot-scope="scope">
                  {{scope.row.receivedAmount}}元
               </template>
            </el-table-column>
              <!-- 折扣金额 -->
              <el-table-column label="折扣金额">
                <template slot-scope="scope">
                    {{scope.row.discount}}元
                </template>
            </el-table-column>
            <!-- 缴费时间 -->
            <el-table-column width="130px" prop="createTime" :label="$t('lang.lab_createFeeHTime')">
              <template slot-scope="scope">
                {{scope.row.createTime|timeYMD}}
              </template>
            </el-table-column>
            <!-- 缴费起始时间 -->
            <el-table-column width="130px" prop="startTime" :label="$t('lang.lab_startFeeHTime')" v-if="diaFree.feeFlag=='1003006'||diaFree.feeTypeCd=='888800010010'">
              <template slot-scope="scope">
                {{scope.row.startTime|timeYMD}}
              </template>
            </el-table-column>
            <!-- 缴费结束时间 -->
            <el-table-column width="130px" prop="endTime" :label="$t('lang.lab_endFeeHTime')" v-if="diaFree.feeFlag=='1003006'||diaFree.feeTypeCd=='888800010010'">
              <template slot-scope="scope">
                {{scope.row.endTime|timeYMD}}
                <!-- {{getDeadlineTime(diaFree)|timeYMD}} -->
              </template>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column prop="stateName" :label="$t('lang.resourStatus')">
              <template slot-scope="scope">
                  <span :style="{color:scope.row.state === '1400'?'blue':''}">{{scope.row.stateName}}</span>
                  <!-- <span v-if="scope.row.state === '1300'" :style="{color:scope.row.state === '1300'?'red':''}">{{scope.row.stateName}}</span>
                  <span v-if="scope.row.state === '1100'" :style="{color:scope.row.state === '1100'?'red':''}">{{scope.row.stateName}}</span> -->
              </template>
            </el-table-column>
            <el-table-column prop="payMethod" :label="$t('lang.lab_payMethod')" width="130px">
               <template slot-scope="scope">
            <span>{{ scope.row.payMethod | payMethodName }}</span>
          </template>
            </el-table-column>
             <el-table-column label="发票号">
               <template slot-scope="scope">
                  {{scope.row.invoiceNo}}
               </template>
            </el-table-column>
             <el-table-column label="开票状态" width="100px">
              <template slot-scope="scope">
                <span v-if="scope.row.invoiceState === 1">已开票</span>
                <span v-else-if="scope.row.invoiceState === 2">开票中</span>
                <span v-else-if="scope.row.invoiceState === 3">已冲红</span>
                <span v-else>{{scope.row.invoiceStateName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="锁定状态" width="90px">
              <template slot-scope="scope">
                <span v-if="isSummaryLocked(scope.row)" style="color:#b86b00;">已锁定</span>
                <span v-else style="color:#16875d;">未锁定</span>
              </template>
            </el-table-column>
             <el-table-column label="收据号">
               <template slot-scope="scope">
                  {{scope.row.billNo}}
               </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_feeLast')">
               <template slot-scope="scope">
                  {{scope.row.feeLast}}
               </template>
            </el-table-column>
            <el-table-column label="缴款人">
               <template slot-scope="scope">
                  {{scope.row.personName}}
               </template>
            </el-table-column>
            <!-- 备注 -->
            <el-table-column prop="remark" :label="$t('lang.resourRemark')" min-width="160" show-overflow-tooltip></el-table-column>
            <!-- 操作 -->
            <el-table-column :label="$t('lang.lab_operation')" width="400">
              <template slot-scope="scope">
                <el-button @click="returnFee(scope.row,red=2)" v-if="scope.row.btn==1 && isFeeManager===1 && scope.row.state!='1800' && !isRefundedHistory(scope.row) && !isSummaryLocked(scope.row)" style="height: 0;line-height: 0;">{{$t('lang.lab_returnFee')}}</el-button>
                <el-button @click="edit(scope.row)" v-if="scope.row.state=='1400' && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{$t('lang.btn_modify')}}</el-button>
                <el-button @click="deleteFee(scope.row,red=0)" v-if="(scope.row.btn==1 || scope.row.feeFlag=='2021101')&& isFeeManager===1 && scope.row.state!='1800' && !isRefundedHistory(scope.row) && !isSummaryLocked(scope.row)" style="height: 0;line-height: 0;">{{$t('lang.btn_delete')}}</el-button>
                <el-button @click="printInvoice(scope.row)" v-if="scope.row.url&&scope.row.url!=''&&scope.row.state=='1400' && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"打票"}}</el-button>
                <el-button @click="supplementInvoice(scope.row)" v-if="scope.row.serialNo&&scope.row.state=='1400'&&!scope.row.url && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"补票"}}</el-button>
                <el-button @click="deleteFee(scope.row,red=1)" v-if="(scope.row.btn==1 || scope.row.feeFlag=='2021101')&& isFeeManager===1&&scope.row.url && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"红冲"}}</el-button>
                <el-button @click="deleteFee(scope.row,red=3)" v-if="(scope.row.btn==1 || scope.row.feeFlag=='2021101')&& isFeeManager===1&&scope.row.billNo && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"作废"}}</el-button>
                <el-button @click="unlockFee(scope.row)" v-if="isSummaryLocked(scope.row) && isFeeManager===1" type="warning" style="height: 0;line-height: 0;">解锁</el-button>
                <el-button @click="print(scope.row)" v-if="scope.row.state=='1400'&&isRelationButton!=1 && scope.row.state!='1800'" style="height: 0;line-height: 0;">{{"打印收据"}}</el-button>
              </template>
            </el-table-column>
          </el-table>
       <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
        class="fee-pagination"
      />
      </div>
    </el-card>
    <el-dialog
      :title="title"
      :visible.sync="isPopupPage"
      :close-on-click-modal="false"
      center
      top="5px !important"
      width="800px"
      @closed="handleDialogClosed"
    >
      <el-form
        :model="diaForm"
        :rules="rules"
        ref="diaForm"
        :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!--  计费起始时间 -->
        <el-form-item
          class="nextPMTime"
          :label="$t('lang.lab_createFeeHTime')"
          prop="createTime"
        >
          <el-date-picker
            v-model="diaForm.createTime"
            type="date"
            value-format="timestamp"
            :placeholder="$t('lang.plh.sel') + $t('lang.lab_startTime')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_payMethod')" prop="payMethod">
          <el-select v-model="diaForm.payMethod" @change="onPayMethodChange">
            <el-option
              v-for="(item,index) in payMethodList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          :label="$t('lang.lab_receiptNumber')"
          prop="receiptNumber"
        >
         <el-input
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_receiptNumber')"
            v-model="diaForm.receiptNumber"
          ></el-input>
        </el-form-item> -->
        <el-form-item :label="isReturnMode ? '退费说明' : '备注'" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            :placeholder="isReturnMode ? '请输入退费说明' : '请输入备注'"
            v-model="diaForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          type="primary"
          @click="save('diaForm')"
          :disabled="isDisabled"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:accessControlEquipmentManagementList
 *@Description:缴费历史
 *@author:xubz
 *@Copyright:格众科技
 */
import { getPayMethodProof } from '@/config/payMethod'

export default {
  data() {
    return {
      isRelationButton:this.$store.getters.isRelationButton,
      isFeeManager: 0,
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 5, // 每页显示数
      rules: {
        createTime: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_createFeeHTime'),
              trigger: 'blur',
          },
        ],
         payMethod: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_payMethod'),
            trigger: 'blur',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入退费说明',
            trigger: 'blur',
          },
        ],
      },
      diaFree: {
        tenants:'',
        builtUpArea: '',
        paymentCycles: [],
        tempCycles: '',
        totalFeePrice: '',
        receivedAmount: '',
        cycles: '',
        remark: '',
        squarePrice: '',
        additionalAmount: '',
        endTime: '',
        feeFlag: '',
        feeName: '',
        feePrice: '',
        feeTypeCdName: '',
        roomName: '',
        // 后加的
        gardenId: '',
        // 缴费信息页面用到的属性
        feeId: '',
        roomDescribe: '',
      },

      // 本页面应用
      params: {},
      roomRow: {},
      value: 0,
      datevalues: '',
      diaFreeProperty: {
        startTime: '',
        endTime: ''
      },
      appHouseholdManageListcheckbox: require('@/config/enum')
        .appHouseholdManageListcheckbox, // 是否隐藏复选框
      diaHistory: [],
      isPopupPage: false,
      title: '',
      diaForm: {
         createTime: '',
         payMethod: '',
         payMethodProof: '',
         receiptNumber: '',
         remark: ''
      },
      editId: '',
      payMethodList: this.$i18n.t('lang.payMethodList'), // 支付方式list
      expands: [],
      isReturnMode: false,
      returnRed: null,
      currentReturnRow: null
    }
  },
  created() {
    this.isFeeManager = this.$store.getters.isFeeManager
    console.log(this.$route.query.params)
    // this.diaFree.gardenId = this.$store.getters.getGardenId
     if (this.$route.query.params['feeId'] == undefined) {
      this.params = JSON.parse(window.localStorage.getItem('paramsls'))
      this.roomRow = JSON.parse(window.localStorage.getItem('rowls'))
    } else {
      window.localStorage.removeItem('paramsls')
      window.localStorage.removeItem('rowls')
      window.localStorage.setItem('paramsls', JSON.stringify(this.$route.query.params))
      window.localStorage.setItem('rowls', JSON.stringify(this.$route.query.row))
      this.params = this.$route.query.params
      this.roomRow = this.$route.query.row
    }
    this.payMoney()
    this.feeDetailHistory()
  },
  watch: {
    diaFree: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule == this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    supplementInvoice(row){
      let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isInvoice'),
            this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            this.$postJson(`/repairFeeInvoice/`, row).then(
                  res => {
                    loading.close()
                    if (res && res.errCode === 0) {
                      this.$message.success(this.$i18n.t('lang.lab_save_success'))
                      this.feeDetailHistory()
                    }
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
          })
           .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
    printInvoice(row){
        window.open(row.url)
    },
    print(row){
        if (!row.billNo || row.billNo.trim() === '') {
          this.$message.warning('该条记录未开收据，无法打印')
          return
        }
        // 给 this.params 增加赋值：收据id(receipt_number)和收据编号（billNo）
        if (row.receiptNumber) {
          this.params.receiptNumber = row.receiptNumber
        }
        if (row.billNo) {
          this.params.billNo = row.billNo
        }
        // 其余所需字段适当增加
        if (row.gardenId) {
          this.params.gardenId = row.gardenId
        }
        if (row.ownerName) {
          this.params.ownerName = row.ownerName
        }
        if (row.roomDescribe) {
          this.params.roomDescribe = row.roomDescribe
        }
        //  this.$router.push({ name: 'feePayPrint', query: { params: this.params, row: row} })
        var p = encodeURIComponent(JSON.stringify(this.params))
        var r = encodeURIComponent(JSON.stringify(row))
         window.open("https://zhwyjk.kmyhwy.cn/feePrint?params="+p+"&row="+r,'_blank')
        // window.open("http://localhost:8082?params="+p+"&row="+r,'_blank')
    },
    deleteFee(row,red) {
        if ((red === 0 || red === 2) && this.isRefundedHistory(row)) {
          this.$message.warning('已退费数据不能进行删除或退费')
          return
        }
        // red=0 表示删除，red=1 表示红冲，red=3 表示作废
        if ((red === 0 || red === 2) && this.isSummaryLocked(row)) {
          this.$message.warning('该缴费记录已被实收汇总单锁定，请先解锁后再进行删除或退费')
          return
        }
        // red=0 表示删除，red=1 表示红冲，red=3 表示作废
        if (red === 0) {
          // 删除操作：如果invoiceNo有值，不能删除，需要进行红冲
          if (row.invoiceNo && row.invoiceNo.trim() !== '') {
            this.$message.warning('该数据已开票，不能删除，需要进行红冲')
            return
          }
          // 如果billNo有值，存在收据不能删除，需要进行作废
          if (row.billNo && row.billNo.trim() !== '') {
            this.$message.warning('该数据已打印收据，不能删除，需要进行作废')
            return
          }
        } else if (red === 1) {
          // 红冲操作：如果invoiceNo无值，不能红冲
          if (!row.invoiceNo || row.invoiceNo.trim() === '') {
            this.$message.warning('该数据不存在发票编号，不能进行红冲')
            return
          }
        } else if (red === 3) {
          // 作废操作：如果billNo无值，不能作废
          if (!row.billNo || row.billNo.trim() === '') {
            this.$message.warning('该数据不存在收据编号，不能进行作废')
            return
          }
        }
        row["red"] =red
        this.executeDeleteFee(row, red)
    },
    executeDeleteFee(row, red) {
        let loading = this.$loading()
        this.$confirm("是否确认该操作？",
            this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            row['feeState'] = '1'
            this.$postJson(`/processFeePayHistoryReturnOrDelete/`, row).then(
                  res => {
                    loading.close()
                    if (res && res.errCode === 0) {
                      if (red === 1) {
                        this.$message.success('红冲成功')
                      } else {
                        this.$message.success(this.$i18n.t('lang.lab_del_success'))
                      }
                      this.feeDetailHistory()
                    } else if (red === 1) {
                      this.$message.error((res && res.errMsg) || '红冲失败')
                    }
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
          })
           .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
    save(diaForm) {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let params = {
              createTimeLong: this.diaForm.createTime,
              payMethod: this.diaForm.payMethod,
              payMethodProof: this.diaForm.payMethodProof || getPayMethodProof(this.diaForm.payMethod),
              receiptNumber: this.diaForm.receiptNumber,
              remark: this.diaForm.remark
            }
            let loading = this.$loading()
            this.$patch(`/updatePayFeeDetailHistory/${this.editId}`, params).then(
              (res) => {
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  // 如果是退费模式，继续调用退费接口
                  if (this.isReturnMode && this.currentReturnRow) {
                    const row = Object.assign({}, this.currentReturnRow, {
                      red: this.returnRed,
                      feeState: '1',
                      remark: this.diaForm.remark
                    })
                    this.$postJson(`/processFeePayHistoryReturnOrDelete`, row).then(
                      (returnRes) => {
                        loading.close()
                        if (returnRes && returnRes.errCode === 0) {
                          this.$message.success(this.$i18n.t('lang.lab_returnFeeSuccess'))
                          this.isPopupPage = false
                          this.feeDetailHistory()
                        }
                      },
                      (error) => {
                        loading.close()
                        this.$message.error(error)
                      }
                    )
                  } else {
                    loading.close()
                    this.isPopupPage = false
                    this.feeDetailHistory()
                  }
                } else {
                  loading.close()
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } else {
            return false
          }
        })
      },
      clear(diaForm) {
			this.$refs[diaForm].resetFields()
      this.diaForm.createTime = ''
      this.diaForm.payMethod = ''
      this.diaForm.payMethodProof = ''
      this.diaForm.remark = ''
      this.isReturnMode = false
      this.returnRed = null
      this.currentReturnRow = null
      setTimeout(() => {
        this.$refs[diaForm].clearValidate()
      }, 0)
    },
     // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.diaForm.resetFields()
      this.diaForm.remark = ''
      this.isReturnMode = false
      this.returnRed = null
      this.currentReturnRow = null
    },
    onPayMethodChange(payMethod) {
      this.diaForm.payMethodProof = getPayMethodProof(payMethod)
    },
    edit(row) {
      this.title = this.$i18n.t('lang.lab_payFeeHistory')
      this.diaForm.createTime = row.createTime
      this.diaForm.payMethod = row.payMethod
      this.diaForm.payMethodProof = getPayMethodProof(row.payMethod)
      this.diaForm.receiptNumber = row.receiptNumber
      this.diaForm.remark = row.remark || ''
      this.editId = row.detailId
      this.isPopupPage = true
      this.isReturnMode = false
      this.returnRed = null
      this.currentReturnRow = null
    },
    feeDetailHistory() {
      let loading = this.$loading()
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gardenId: this.params.gardenId,
        feeId: this.params.feeId,
        startTs: this.diaFreeProperty.startTime,
        endTs: this.diaFreeProperty.endTime,
      }
      this.$get(`/payFeeDetailHistory/`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.diaHistory = res.list.map(item => Object.assign({}, item, { ruleItemData: [] }))
            this.pageCount = res.pageCount
            this.expands = []
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    returnFee(row,red) {
      if (this.isRefundedHistory(row)) {
        this.$message.warning('已退费数据不能进行退费')
        return
      }
      if (this.isSummaryLocked(row)) {
        this.$message.warning('该缴费记录已被实收汇总单锁定，请先解锁后再进行退费')
        return
      }
      // 退费时先弹出对话框填写退费说明，再真正退费
      this.title = this.$i18n.t('lang.lab_returnFee') || '退费'
      this.diaForm.createTime = row.createTime
      this.diaForm.payMethod = row.payMethod
      this.diaForm.payMethodProof = getPayMethodProof(row.payMethod)
      this.diaForm.receiptNumber = row.receiptNumber
      this.diaForm.remark = row.remark || ''
      this.editId = row.detailId
      this.isPopupPage = true
      this.isReturnMode = true
      this.returnRed = red
      this.currentReturnRow = row
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    isSummaryLocked(row) {
      if (!row) {
        return false
      }
      return Number(row.summaryLock) === 1
    },
    isRefundedHistory(row) {
      if (!row) {
        return false
      }
      const state = String(row.state || '')
      return state === '1100' || state === '1300'
    },
    unlockFee(row) {
      if (!row || !row.detailId) {
        return
      }
      this.$confirm('确认解锁该缴费记录？解锁后可进行删除或退费。', this.$i18n.t('lang.lab_prompt'), {
        confirmButtonText: this.$i18n.t('lang.btn_confirm'),
        cancelButtonText: this.$i18n.t('lang.btn_cancel'),
        type: 'warning'
      }).then(() => {
        const loading = this.$loading()
        this.$post(`/unlockPayFeeDetail/${row.detailId}`).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success('解锁成功')
              this.feeDetailHistory()
            } else if (res && res.errMsg) {
              this.$message.warning(res.errMsg)
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }).catch(() => {})
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getRowKeys(row) {
      return row.detailId
    },
    rowClick(row, expandedRows) {
      const isExpanded = Array.isArray(expandedRows) && expandedRows.some(item => item.detailId === row.detailId)
      if (!isExpanded) {
        this.expands = []
        return
      }
      let loading = this.$loading()
      let params = {
        detailId: row.detailId
      }
      this.$get(`/feeActualListByGardenId/`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            const ruleItems = res.list.map(item => {
              this.$set(item, 'feeFlag', row.feeFlag)
              return item
            })
            const idx = this.diaHistory.findIndex(item => item.detailId === row.detailId)
            if (idx !== -1) {
              this.$set(this.diaHistory[idx], 'ruleItemData', ruleItems)
            }
            this.expands = [row.detailId]
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    getDeadlineTime(fee) {
      if (fee.endTime == fee.receiveTime) {
        return '―'
      }

      if (fee.state == '2009001') {
        return '―'
      }

      return fee.receiveTime
    },
    getEndTime: function (fee) {
      if (fee.state == '2009001') {
        // 如果收费结束
        return '―'
      }
      return fee.endTime
    },
    jump() {
      this.$router.push({
        name: 'feeRoomList',
        query: { row: this.roomRow },
      })
    },
    // 收费  许
    payMoney() {
      let loading = this.$loading()

      this.$get(`/feePayInfo/`, this.params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.diaFree = res.list[0]
            let cycless = []
            if (res.list[0].paymentCycle > 12) {
              cycless = [1, 2, 3, 6, 9, 12]
            } else {
              for (let _index = 1; _index < 7; _index++) {
                cycless.push(_index * res.list[0].paymentCycle)
              }
            }

            this.diaFree.paymentCycles = cycless
            this.diaFree.totalFeePrice = res.list[0].feePrice
            this.isDisabled = false
            // this.isPopupPage = true
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
     // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.feeDetailHistory()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.feeDetailHistory()
    },
  },
}
</script>

<style lang="scss">
.nextPMTime label {
  width: 150px !important;
}

// .el-dialog .el-form .el-form-item {
//   margin-right: 0;
//   margin-bottom: 15px !important;
// }
.tagStyle {
  width: 100px;
  margin-top: 3px;
}
.el-tag.el-tag--info {
  background-color: #cdcdd0 !important;
  border-color: #fcf9f9 !important;
  color: #37383a !important;
}

.el-dialog__header {
  border-bottom: none !important;
}

.el-dialog .el-form {
  padding: 0px 10px 0 0px !important;
}

.el-divider--horizontal {
  margin: 7px 0 !important;
}
.el-divider--vertical {
  height: 25em !important;
  margin: 0 15px !important;
}
.inputSelect {
  width: 50% !important;
}
.inputSelect > .el-input {
  width: 100% !important;
}

.mediumfee {
  height: 32px !important;
  line-height: 32px !important;
  font-size: 25px !important;
  width: 150px !important;
}
.feePropertyList {
  height: 100%;
}

.filters {
  padding: 5px 10px 10px 10px !important;
}
.feePro{
  -webkit-box-shadow: none !important;;
  box-shadow: none !important;;
}
.diaFreeTable {
  height: 100%;
}
.diaFreeTable >td {
  padding: 5px 0 !important;
}
.fee-pagination {
      padding: 5px 5px !important;
}
.feeMsg .el-form-item {
      margin-bottom: 0 !important;
}
.el-card__body{
  overflow: auto;
}
.feeMsg{
  min-width: 1000px;
}
</style>